// Hero images for each week - featuring diverse women in their 40s engaged in weekly themes
const weekHeroImages = {
  1: {
    url: "https://static.prod-images.emergentagent.com/jobs/e3530b31-97d2-4c5b-b8f4-f9284f31d094/images/a488f49962008da52605ead6526da490b23586c70f4d5416302450a438f715f1.png",
    alt: "Full body shot of woman meditating on yoga mat in bright living room - Foundation and Mindset"
  },
  2: {
    url: "https://static.prod-images.emergentagent.com/jobs/e3530b31-97d2-4c5b-b8f4-f9284f31d094/images/dca92bcb38a50e61ee76d68761c489664369263771944721ea24a1ce8808236a.png",
    alt: "Full body shot of woman chopping fresh vegetables in modern kitchen - Nutrition Essentials"
  },
  3: {
    url: "https://static.prod-images.emergentagent.com/jobs/e3530b31-97d2-4c5b-b8f4-f9284f31d094/images/d52de307f4cb3486ec503d8148421ae36243c4223ac8798a171e6dd73cfc717e.png",
    alt: "Full body shot of woman at bathroom vanity with skincare products - Skincare Rituals"
  },
  4: {
    url: "https://static.prod-images.emergentagent.com/jobs/e3530b31-97d2-4c5b-b8f4-f9284f31d094/images/91202b9276e47b97b9f0733942b156163eae04287beff9e0a912c8a78f910c82.png",
    alt: "Full body shot of athletic woman in warrior yoga pose - Movement and Strength"
  },
  5: {
    url: "https://static.prod-images.emergentagent.com/jobs/e3530b31-97d2-4c5b-b8f4-f9284f31d094/images/4eacbc68ba574bbfa52c64b7a5eeaedf5afe335f73660187cdbacbfa6084037c.png",
    alt: "Full body shot of woman reading book in cozy bed - Sleep and Recovery"
  },
  6: {
    url: "https://static.prod-images.emergentagent.com/jobs/e3530b31-97d2-4c5b-b8f4-f9284f31d094/images/f2b68053d1269de627a33029b0a551c48ef729e4af06df358448fd946c73f27f.png",
    alt: "Full body shot of woman on garden bench surrounded by flowers - Stress Management"
  },
  7: {
    url: "https://static.prod-images.emergentagent.com/jobs/e3530b31-97d2-4c5b-b8f4-f9284f31d094/images/e362fa40fc16910fa5b79ac669b3a9f1a4f009d5926b49f7a900c94e435888f4.png",
    alt: "Full body shot of woman trying on blazer in front of mirror - Confidence and Style"
  },
  8: {
    url: "https://static.prod-images.emergentagent.com/jobs/e3530b31-97d2-4c5b-b8f4-f9284f31d094/images/66f84b37b18824d952cd66035336104579e8e082c537e7737423c4a4629114e3.png",
    alt: "Full body shot of professional woman at home office desk - Career Empowerment"
  },
  9: {
    url: "https://static.prod-images.emergentagent.com/jobs/e3530b31-97d2-4c5b-b8f4-f9284f31d094/images/6d50f87d0f6e264611573d5cf3500029a92e110fb5f92f88a5ebd83f57c87b73.png",
    alt: "Full body shot of woman at outdoor cafe with sparkling water - Alcohol Reduction"
  },
  10: {
    url: "https://static.prod-images.emergentagent.com/jobs/e3530b31-97d2-4c5b-b8f4-f9284f31d094/images/8e31bda43d3f0fc93bc19e24cc6e6939d5ac25997e851444d4ee2966dba1eb1b.png",
    alt: "Full body shot of diverse women friends laughing at brunch - Social Connections"
  },
  11: {
    url: "https://static.prod-images.emergentagent.com/jobs/e3530b31-97d2-4c5b-b8f4-f9284f31d094/images/6cf9ff99047661dd325d0161f841b8359889db5426c297209b99d74f35533353.png",
    alt: "Full body shot of woman painting in bright art studio - Creative Expression"
  },
  12: {
    url: "https://static.prod-images.emergentagent.com/jobs/e3530b31-97d2-4c5b-b8f4-f9284f31d094/images/48af745c8692c0a28eb8d28450fabf96951bfdc26390c2de2ba02893301a9da5.png",
    alt: "Full body shot of woman with arms outstretched in flower garden at sunset - Keeping Your Glow"
  }
};

export default weekHeroImages;
